export const ROLE_PARENT_ACCESS: Record<string, string[]> = {
    ADMIN: [
        "Dashboard", "Users", "Manajemen", "Pembelian", "Penjualan",
        "Pembayaran", "Products", "Packing Order", "Antrian Order",
        "Absensi", "Report", "Pengiriman Kurir",
    ],

    SERVER: [
        "Dashboard", "Users", "Manajemen", "Pembelian", "Penjualan",
        "Pembayaran", "Packing Order", "Antrian Order",
        "Absensi", "Report", "Pengiriman Kurir",
    ],

    MANAGER: [
        "Dashboard", "Users", "Manajemen", "Pembelian", "Penjualan",
        "Pembayaran", "Packing Order", "Antrian Order",
        "Absensi", "Report", "Pengiriman Kurir",
    ],

    PACKING: [
        "Penjualan", "Packing Order", "Antrian Order", "Pengiriman Kurir", "Absensi"
    ],

    COURIER: [
        "Pengiriman Kurir", "Absensi"
    ],

    SUPERADMIN: ["ALL"],
};

export const ROLE_SUBMENU_ACCESS: Record<string, any> = {
    ADMIN: {
        Penjualan: ["Data Penjualan", "Tambah Penjualan"],
    },
    SERVER: {
        Penjualan: ["Data Penjualan", "Tambah Penjualan"],
    },
    MANAGER: {
        Penjualan: ["Data Penjualan", "Tambah Penjualan"],
    },
    PACKING: {
        Penjualan: ["Data Penjualan"], // Tidak boleh lihat Tambah Penjualan
    },
    COURIER: {
        // tidak ada submenu
    },
    SUPERADMIN: "ALL",
};
